import type { FunctionComponent, ReactElement } from 'react';

import classNames from 'classnames';

import Icon, { ICONS } from '../../icons/icon';
import { Link } from '../link/link';
import TooltipTrigger from '../tooltip_trigger/tooltip_trigger';

import emptyResultsSvg from '../../images/empty_results_default.svg';

import styles from './no_content.module.css';

type Size = 'm' | 's';

type Props = {
  title: string;
  actionLink?: string;
  actionText?: string;
  onActionClick?: () => void;
  image?: string;
  size?: Size;
  errorText?: string;
  description?: ReactElement;
  className?: string;
};

const sizeStyleClass = {
  m: styles.m,
  s: styles.s,
};

const NoContent: FunctionComponent<Props> = (props) => {
  const {
    title,
    actionLink,
    actionText,
    onActionClick,
    image = emptyResultsSvg,
    size = 's',
    errorText,
    description = null,
    className,
  } = props;

  let link;
  if (actionLink) {
    if (actionLink.startsWith('http')) {
      link = (
        <a
          className={styles.action}
          href={actionLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          {actionText}
        </a>
      );
    } else {
      link = (
        <Link className={styles.action} to={actionLink} onClick={onActionClick}>
          {actionText}
        </Link>
      );
    }
  }
  return (
    <div
      className={classNames(styles.root, className)}
      role="region"
      aria-label="No content"
    >
      <div className={styles.message}>
        <img
          src={image}
          alt=""
          className={classNames(styles.image, sizeStyleClass[size])}
        />
        {size === 'm' ? (
          <h2 className={styles.title}>{title}</h2>
        ) : (
          <h3 className={styles.title}>{title}</h3>
        )}
        {description}
        {errorText && (
          <TooltipTrigger placement="bottom" tooltipText={errorText}>
            <Icon
              className={classNames(styles.title, styles.info_icon)}
              icon={ICONS.Info}
            />
          </TooltipTrigger>
        )}
        {actionLink && actionText ? link : null}
        {!actionLink && onActionClick && actionText ? (
          <button className={styles.action} onClick={onActionClick}>
            {actionText}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default NoContent;
